import {
	FETCH_PERMISSIONS_SUCCESS,
	FETCH_PERMISSION_SUCCESS,
} from "../../constants/ActionTypes";

const initialSettings = {};

export default (state = initialSettings, action) => {
	switch (action.type) {
		case FETCH_PERMISSIONS_SUCCESS: {
			return { ...state, index: action.payload };
		}
		case FETCH_PERMISSION_SUCCESS: {
			return { ...state, show: action.payload };
		}
		default:
			return state;
	}
};
